import FacilityId           from "../facility/FacilityId";
import Time                 from "../fundamentals/date/Time";
import Reservation          from "./Reservation";
import ReservationTimeLines from "./ReservationTimeLines";

class Reservations {
  constructor(
    private readonly _list: Reservation[] = [],
    private readonly _timelines: ReservationTimeLines = new ReservationTimeLines()
  ) {
  }

  public isEmpty(): boolean {
    return this._list.length <= 0;
  }

  public toList(): Reservation[] {
    return this._list;
  }

  public filterByFacility(facilityId: FacilityId): Reservations {
    const reservations: Reservation[] = this._list.filter(reservation => reservation.facility.id.equals(facilityId));
    return new Reservations(reservations, this._timelines);
  }

  public filterByTime(time: Time): Reservations {
    const reservations: Reservation[] = this._list.filter(reservation => reservation.within(time));
    return new Reservations(reservations, this._timelines);
  }

  get timelines() {
    return this._timelines;
  }
}

export default Reservations;
